import { GetImages } from "../../utils/GetImages";
import { TextCss } from "../GlobalCss/TextCss";
// pass this class if you want blue backround for 80px height width,imgBackgroundClass= {Background.LightBlue.Round.round80}
const EmptyData = ({
  mainText,
  subText = undefined,
  button = undefined,
  ImageSrc = GetImages.emptyStateData,
  imgBackgroundClass=undefined
}) => {
  return (
    <>
      <div className="EmptyScreen">
        <div className="d-flex flex-column align-items-center justify-content-center gap-2 h-100">
          {imgBackgroundClass ? (
            <div className={imgBackgroundClass}>
          <img src={ImageSrc} />
          </div>
          ):
          <div className="">
          <img src={ImageSrc} className="iconStyleWithWhiteFilter"/>
          </div>}
          <p className={TextCss.black.main_heading_700_20}>{mainText}</p>
          <p className="text-center grey_subtext1">{subText}</p>
          {!button ? "" : button}
        </div>
      </div>
    </>
  );
};

export default EmptyData;
